import { Map, Record } from "immutable";

import { Content, Contents } from "./contents/Contents";
import Course from "./courses/course/Course";
import { Courses } from "./courses/Courses";
import CoursesMeta from "./courses/meta";
import { ContentModule, Modules } from "./modules/Modules";
import { Section, Sections } from "./sections/Sections";

export type CoursesStateSliceType = {
  courses: Courses;
  sections: Sections;
  contents: Contents;
  modules: Modules;
  meta: CoursesMeta;
};

export type OptionalCoursesStateSliceType = Partial<CoursesStateSliceType>;

const coursesStateSlice: CoursesStateSliceType = {
  courses: Map<string, Course>(),
  sections: Map<string, Section>(),
  contents: Map<string, Content>(),
  modules: Map<string, ContentModule>(),
  meta: new CoursesMeta()
};

export default class CoursesStateSlice extends Record(coursesStateSlice) {}
